import { CategoryInfo } from '@/types';

export const categories: CategoryInfo[] = [
  {
    id: 'mobile-living',
    icon: 'truck',
    name: 'Mobile Living',
    description: 'Life on wheels — vans, buses, and tiny homes that move with you.',
  },
  {
    id: 'off-grid-homes',
    icon: 'home',
    name: 'Off-Grid Homes',
    description: 'Self-sufficient living in tiny houses, dome homes, and cabins.',
  },
  {
    id: 'boat-living',
    icon: 'sailboat',
    name: 'Boat Living',
    description: 'Make the water your home — marina life and sailing adventures.',
  },
  {
    id: 'camping',
    icon: 'tent',
    name: 'Camping',
    description: 'Outdoor living, tent life, and the freedom of the wild.',
  },
];

export const getCategoryById = (id: string): CategoryInfo | undefined => {
  return categories.find(cat => cat.id === id);
};
